<template>
  <div class="line-broadcast-dropdown" ref="dropdownRef">
    <div class="line-broadcast-dropdown_trigger" @click="handleOnClick">
      <div class="trigger-content-container">
        <slot name="trigger"></slot>
      </div>
      <i :class="`bx ${isInternalOpen ? 'bx-caret-up' : 'bx-caret-down'}`" />
    </div>
    <div v-if="isInternalOpen" class="line-broadcast-dropdown_panel" @click.stop>
      <slot name="panel"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LineBroadcastDropdown',
  props: {
    isControlled: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
    },
  },
  data() {
    return {
      isInternalOpen: this.isControlled ? this.isOpen : false,
    };
  },
  methods: {
    handleOnClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.isInternalOpen = !this.isInternalOpen;
      if (this.isControlled) {
        this.$emit('on-click-dropdown', this.isInternalOpen);
      }
    },
    handleClickOutside(event) {
      const dropdown = this.$refs.dropdownRef;
      if (!dropdown || dropdown.contains(event.target)) {
        return;
      }
      this.isInternalOpen = false;
      if (this.isControlled) {
        this.$emit('on-click-dropdown', this.isInternalOpen);
      }
    },
  },
  mounted() {
    document.addEventListener('mousedown', this.handleClickOutside, true);
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.handleClickOutside, true);
  },
};
</script>
<style lang="scss" scoped>
.line-broadcast-dropdown {
  min-width: 300px;
  max-width: 100%;
  position: relative;
  .line-broadcast-dropdown_trigger {
    min-height: 46px;
    display: flex;
    align-items: center;
    border: 1px solid #4848ff;
    background-color: #ffffff;
    border-radius: 8px;
    padding: 8px 12px;
    cursor: pointer;
    .bx {
      color: #868ba6;
    }
    .trigger-content-container {
      flex: 1;
    }
  }
  &_panel {
    max-height: 387px;
    width: 100%;
    border-radius: 8px;
    gap: 10px;
    padding: 12px 16px;
    background-color: #ffffff;
    border: 1px solid #dadce4;
    box-shadow: 0px 4px 8px 0px rgba(134, 139, 166, 0.2);
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    position: absolute;
    z-index: 1;
  }
}
</style>
